<template>
  <el-dialog
    title="批量选择交货地点"
    :visible.sync="showDialog"
    width="600px"
    :append-to-body="false"
    :before-close="clearDialog"
    style="z-index: 1;"
    @open="onOpen"
  >
    <el-form
      ref="form"
      label-suffix="："
      label-width="100px"
      :model="form"
      :rules="rules"
    >
      <el-form-item label="工厂编码" prop="factory">
        <el-select
          v-model="form.factory"
          filterable
          default-first-option
          placeholder="请选择工厂编码"
          @change="factoryChange"
        >
          <el-option
            v-for="item in factoryOptions"
            :key="item"
            :label="item"
            :value="item"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="交货地点" prop="deliveryAddress">
        <el-select v-model="form.deliveryAddress" placeholder="请选择交货地点">
          <el-option
            v-for="item in deliveryAddressOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="confirm">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
// 后端api
import {
  getPurchaseFactoryListApi,
  getPurchaseAddressByFactoryApi
} from '@/api/purchase-demand/address'

export default {
  name: 'AddressDialog',

  model: {
    prop: 'showDialog',
    event: 'change'
  },

  props: {
    showDialog: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      factoryOptions: [], // 工厂编码下拉列表
      deliveryAddressOptions: [], // 收货地点下拉列表

      form: {
        factory: '',
        deliveryAddress: ''
      },

      rules: {
        factory: [
          {
            required: true,
            message: '请选择工厂编码',
            trigger: ['blur', 'change']
          }
        ],
        deliveryAddress: [
          {
            required: true,
            message: '请选择收货地点',
            trigger: ['blur', 'change']
          }
        ]
      }
    }
  },

  computed: {
    visible: {
      get() {
        return this.showDialog
      },
      set(val) {
        this.$emit('change', val)
      }
    }
  },

  methods: {
    onOpen() {
      this.getFactoryList()

      this.$nextTick(() => {
        this.form.factory = ''
        this.form.deliveryAddress = ''
        this.$refs.form.resetFields()
      })
    },

    /**
     * 获取工厂编码下拉列表
     */
    async getFactoryList() {
      await getPurchaseFactoryListApi()
        .then(res => {
          const data = res.data || []
          this.factoryOptions = data
        })
        .catch(err => {
          this.$message.error(err.message || '获取工厂编码失败')
        })
    },

    /**
     * 获取交货地点下拉列表
     */
    getAddressList(factory) {
      getPurchaseAddressByFactoryApi(factory)
        .then(res => {
          const data = res.data || []
          this.deliveryAddressOptions = data.map(item => ({
            value: `${item.addressCode},${item.addressName}`,
            label: item.addressName
          }))
        })
        .catch(err => {
          this.$message.error(err.message || '获取交货地点失败')
        })
    },

    /**
     * 工厂编码切换
     */
    factoryChange(value) {
      this.form.deliveryAddress = ''
      this.getAddressList(value)
    },

    // 关闭对话框时，执行的函数
    clearDialog() {
      this.$emit('change', false)
    },
    confirm() {
      this.$refs.form.validate().then(valid => {
        if (!valid) return

        this.$confirm(`是否确定批量选择交货地点？`, '提示', {
          type: 'warning'
        }).then(() => {
          this.$emit('confirm', this.form)
          this.clearDialog()
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
